import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TooltipPortal from "../../../../parts/tooltip-portal";
import { initBlankState } from "../gym-locations";
import copy from "clipboard-copy";
import SettingsNav from "../../../../parts/settings-nav";
import SvgIcon from "../../../../parts/SvgIcon";
import { SettingsBackHandler } from "../../../coaching-portal/settings/components/SettingsBackHandler";

const NewGymComponent = ({ locals }) => {
  const { t } = useTranslation(["dashboard", "common"]);
  //state for the checkbox in working days
  const [dayState, setDayState] = useState([""]);
  //state for the checkbox in same as above
  const [sameAsAboveState, setSameAsAboveState] = useState([""]);
  //init state
  const [formState, setFormState] = useState(initBlankState);
  // Team Coach can view org settings but not change them — the server
  // already rejects the POST, this just keeps the save button from
  // silently failing.
  const isReadOnly = locals?.organizationRoleName === "Team Coach";

  /** English names — used for form field names and API payloads */
  const weekdayKeys = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  /**
   * set the checkbox in working days
   * @param {*} value
   */
  const handleSelectionChange = (value) => {
    let data = JSON.parse(JSON.stringify(dayState));
    if (!dayState.includes(value)) {
      data.length === 1 && data[0].length === 0
        ? (data = [value])
        : data.push(value);
    } else {
      if (dayState.length > 0) {
        const filetered = data.filter((val) => val != value);
        data = filetered.length > 0 ? filetered : [""];
      }
    }
    setDayState(data);
  };

  /**
   * set the data with the above information
   * @param {*} day
   */
  const handleSameAsAboveData = (day) => {
    let endHoursOfOperationValue = "";
    let endHoursStaffHourValue = "";
    let initHoursOfOperationValue = "";
    let initHoursStaffHoursValue = "";

    if (day === "Tuesday") {
      endHoursOfOperationValue = formState["endHoursOfOperationOfMonday"];
      endHoursStaffHourValue = formState["endHoursStaffHoursOfMonday"];
      initHoursOfOperationValue = formState["initHoursOfOperationOfMonday"];
      initHoursStaffHoursValue = formState["initHoursStaffHoursOfMonday"];
    } else if (day === "Wednesday") {
      endHoursOfOperationValue = formState["endHoursOfOperationOfTuesday"];
      endHoursStaffHourValue = formState["endHoursStaffHoursOfTuesday"];
      initHoursOfOperationValue = formState["initHoursOfOperationOfTuesday"];
      initHoursStaffHoursValue = formState["initHoursStaffHoursOfTuesday"];
    } else if (day === "Thursday") {
      endHoursOfOperationValue = formState["endHoursOfOperationOfWednesday"];
      endHoursStaffHourValue = formState["endHoursStaffHoursOfWednesday"];
      initHoursOfOperationValue = formState["initHoursOfOperationOfWednesday"];
      initHoursStaffHoursValue = formState["initHoursStaffHoursOfWednesday"];
    } else if (day === "Friday") {
      endHoursOfOperationValue = formState["endHoursOfOperationOfThursday"];
      endHoursStaffHourValue = formState["endHoursStaffHoursOfThursday"];
      initHoursOfOperationValue = formState["initHoursOfOperationOfThursday"];
      initHoursStaffHoursValue = formState["initHoursStaffHoursOfThursday"];
    } else if (day === "Saturday") {
      endHoursOfOperationValue = formState["endHoursOfOperationOfFriday"];
      endHoursStaffHourValue = formState["endHoursStaffHoursOfFriday"];
      initHoursOfOperationValue = formState["initHoursOfOperationOfFriday"];
      initHoursStaffHoursValue = formState["initHoursStaffHoursOfFriday"];
    } else {
      endHoursOfOperationValue = formState["endHoursOfOperationOfSaturday"];
      endHoursStaffHourValue = formState["endHoursStaffHoursOfSaturday"];
      initHoursOfOperationValue = formState["initHoursOfOperationOfSaturday"];
      initHoursStaffHoursValue = formState["initHoursStaffHoursOfSaturday"];
    }

    const newState = Object.assign({}, formState, {
      [`endHoursOfOperationOf${day}`]: endHoursOfOperationValue,
      [`endHoursStaffHoursOf${day}`]: endHoursStaffHourValue,
      [`initHoursOfOperationOf${day}`]: initHoursOfOperationValue,
      [`initHoursStaffHoursOf${day}`]: initHoursStaffHoursValue,
    });

    setFormState(newState);
  };

  /**
   * set the check colors in same as above
   * @param {*} day
   */
  const handleSameAsAbove = (day) => {
    //code for the check color
    let data = JSON.parse(JSON.stringify(sameAsAboveState));
    if (!sameAsAboveState.includes(day)) {
      data.length === 1 && data[0].length === 0
        ? (data = [day])
        : data.push(day);
    } else {
      if (sameAsAboveState.length > 0) {
        const filetered = data.filter((val) => val != day);
        data = filetered.length > 0 ? filetered : [""];
      }
    }
    setSameAsAboveState(data);

    //code for set the same data
    handleSameAsAboveData(day);
  };

  /**
   * set input changes in the form value
   * @param {*} e
   */
  const onInputChange = async (e) => {
    const { name, value } = e.target;

    const newState = Object.assign({}, formState, {
      [`${name}`]: value,
    });

    setFormState(newState);
  };

  /**
   * Validate maplink
   * @returns
   */
  const validateMapLink = () => {
    if (!formState["gymMapLink"]) {
      return true;
    }

    if (formState["gymMapLink"]) {
      const regex = /@([-0-9.]+),([-0-9.]+)/;
      const match = formState["gymMapLink"].match(regex);
      return match;
    }

    return false;
  };

  const saveDisabled = isReadOnly || !validateMapLink();
  const saveTooltipMessage = isReadOnly
    ? t("settingsNav.readOnlyTooltip")
    : t("gymLocations.googleMapLinkTooltip");

  return (
    <main className="settings">
      <SettingsNav classNames="mobile-hidden" />
      <section className="add-new-gym">
        <header>
          <SettingsBackHandler title={t("gymLocations.addNewGym")} />
          <hgroup className="mobile-hidden">
            <a
              href={"/coaching-portal/settings/gym-locations"}
              role="button"
              data-button-type="secondary"
              data-icon-only
            >
              <SvgIcon
                width={20}
                height={20}
                src="/img/new-icons/back-button.svg"
                alt={t("common:back")}
              />
            </a>
            <p className="s1">{t("gymLocations.addNewGym")}</p>
          </hgroup>
        </header>

        <form
          id="form-storefront"
          method="POST"
          encType="multipart/form-data"
          data-noreset
        >
          <div className="row">
            <div>
              <label>{t("branding.gymName")}</label>
              <input
                placeholder={t("gymLocations.enterGymName")}
                name="gymName"
                onChange={onInputChange}
                value={formState["gymName"]}
                type="text"
                className="text-input"
                required
                sz="large"
              />
            </div>
            <div className="input-group input-group-new-gym direction-form-column">
              <label className="label req" htmlFor="gymLocation">
                {t("gymLocations.location")}
              </label>
              <input
                placeholder={t("gymLocations.enterCityName")}
                name="gymLocation"
                onChange={onInputChange}
                value={formState["gymLocation"]}
                type="text"
                className="text-input"
                required
                sz="large"
              />
            </div>
          </div>
          <div className="row">
            <div>
              <label className="label req" htmlFor="gymEmail">
                {t("gymLocations.gymEmail")}
              </label>
              <input
                placeholder={t("gymLocations.enterGymEmail")}
                name="gymEmail"
                onChange={onInputChange}
                value={formState["gymEmail"]}
                type="text"
                className="text-input"
                required
                sz="large"
              />
            </div>
            <div>
              <label htmlFor="gymContact">{t("gymLocations.gymContact")}</label>
              <input
                placeholder={t("gymLocations.enterGymContact")}
                name="gymContact"
                onChange={onInputChange}
                value={formState["gymContact"]}
                type="text"
                className="text-input"
                required
                sz="large"
              />
            </div>
          </div>
          <div className="row">
            <div>
              <label
                htmlFor="gymMapLink"
                style={!validateMapLink() ? { color: "#e90b34" } : {}}
              >
                {t("gymLocations.googleMapLink")}
              </label>
              <div className="input-with-copy">
                <img alt={t("gymLocations.linkAlt")} src="/img/new-icons/link.svg" />
                <input
                  placeholder={t("gymLocations.pasteGoogleMapLink")}
                  name="gymMapLink"
                  onChange={onInputChange}
                  value={formState["gymMapLink"]}
                  type="text"
                  className="text-input"
                  required
                  sz="large"
                />
                <button
                  data-button-type="secondary"
                  data-icon
                  data-icon-only
                  className={`copy-new-gym${
                    !formState["gymMapLink"] || !validateMapLink()
                      ? " invisible"
                      : ""
                  }`}
                  onClick={async (e) => {
                    e.preventDefault();
                    await copy(formState["gymMapLink"]);
                  }}
                >
                  <img alt={t("gymLocations.copyAlt")} src="/img/new-icons/copy.svg" />
                </button>
              </div>
            </div>
            <div>
              <label className="label" htmlFor="facilikey">
                {t("gymLocations.facilikey")}
              </label>
              <div className="input-with-copy">
                <img alt={t("gymLocations.linkAlt")} src="/img/new-icons/link.svg" />
                <input
                  placeholder={t("gymLocations.pasteKey")}
                  name="facilikey"
                  onChange={onInputChange}
                  value={formState["facilikey"]}
                  type="text"
                  className="text-input"
                  sz="large"
                />
                <button
                  data-button-type="secondary"
                  data-icon
                  data-icon-only
                  className={`copy-new-gym${
                    !formState["facilikey"] ? " invisible" : ""
                  }`}
                  onClick={async (e) => {
                    e.preventDefault();
                    await copy(formState["facilikey"]);
                  }}
                >
                  <img alt={t("gymLocations.copyAlt")} src="/img/new-icons/copy.svg" />
                </button>
              </div>
            </div>
          </div>
          <section role="table-wrapper" data-borders-inside>
            <div className="inputs-new-gym">
              {/* hidden inputs section */}
              <input
                name="workingDays"
                defaultValue={dayState}
                style={{ display: "none" }}
              ></input>
              <input
                name="daysWithSameAsAbove"
                defaultValue={sameAsAboveState}
                style={{ display: "none" }}
              ></input>
              <input
                name="requestType"
                defaultValue="post"
                style={{ display: "none" }}
              ></input>
            </div>
            <table role="report-table">
              <thead className="new-gym-table-header">
                <tr>
                  <th></th>
                  <th className="gym-location-form-width">{t("gymLocations.workingDays")}</th>
                  <th className="gym-location-form-width">
                    {t("gymLocations.hoursOfOperations")}
                  </th>
                  <th>{t("gymLocations.staffHours")}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody className="new-gym-main-table-content">
                {weekdayKeys.map((day, index) => {
                  const checked = dayState.includes(day);
                  const sameAsAbove = sameAsAboveState.includes(day);
                  return (
                    <tr className="new-gym-table-content" key={day}>
                      <td>
                        <SvgIcon
                          src={`/img/new-icons/${
                            checked ? "checked-square" : "unchecked-square"
                          }.svg`}
                          onClickFn={() => handleSelectionChange(day)}
                          noFilterOnLight={checked}
                        />
                      </td>
                      <td className="gym-location-form-width">
                        {t(`gymLocations.weekdays.${day.toLowerCase()}`)}
                      </td>
                      <td className="gym-location-form-width">
                        <div className="div-text-hours">
                          <input
                            placeholder="10:00 AM"
                            name={`initHoursOfOperationOf${day}`}
                            value={formState[`initHoursOfOperationOf${day}`]}
                            onChange={onInputChange}
                            type="time"
                            pattern="[0-9]{2}:[0-9]{2}"
                            className="text-input text-input-hour-div"
                            readOnly={sameAsAbove || !checked}
                          />
                          <span>{t("metrics.to")}</span>
                          <input
                            placeholder="10:00 PM"
                            name={`endHoursOfOperationOf${day}`}
                            value={formState[`endHoursOfOperationOf${day}`]}
                            onChange={onInputChange}
                            type="time"
                            pattern="[0-9]{2}:[0-9]{2}"
                            className="text-input text-input-hour-div"
                            readOnly={sameAsAbove || !checked}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="div-text-hours">
                          <input
                            placeholder="10:00 AM"
                            name={`initHoursStaffHoursOf${day}`}
                            value={formState[`initHoursStaffHoursOf${day}`]}
                            onChange={onInputChange}
                            type="time"
                            pattern="[0-9]{2}:[0-9]{2}"
                            className="text-input text-input-hour-div"
                            readOnly={sameAsAbove || !checked}
                          />
                          <span>{t("metrics.to")}</span>
                          <input
                            placeholder="10:00 PM"
                            name={`endHoursStaffHoursOf${day}`}
                            value={formState[`endHoursStaffHoursOf${day}`]}
                            onChange={onInputChange}
                            type="time"
                            pattern="[0-9]{2}:[0-9]{2}"
                            className="text-input text-input-hour-div"
                            readOnly={sameAsAbove || !checked}
                          />
                        </div>
                      </td>
                      <td>
                        {index !== 0 && (
                          <div
                            className="same-as-above-div"
                            onClick={
                              !dayState.includes(day)
                                ? null
                                : () => handleSameAsAbove(day)
                            }
                            aria-disabled={
                              !dayState.includes(day) ? true : undefined
                            }
                          >
                            <SvgIcon
                              src={`/img/new-icons/${
                                sameAsAboveState.includes(day)
                                  ? "tick-circle"
                                  : "radio-unchecked"
                              }.svg`}
                            />

                            <span className="same-as-above-text">
                              {t("gymLocations.sameAsAbove")}
                            </span>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </section>
          <div className="gym-contract-buttons">
            {saveDisabled ? (
              <TooltipPortal body={saveTooltipMessage}>
                <button type="button" data-button-type="primary" disabled>
                  {t("common:save")}
                </button>
              </TooltipPortal>
            ) : (
              <button data-button-type="primary" type="submit">
                {t("common:save")}
              </button>
            )}
            <a
              data-button-type="secondary"
              data-action="cancel"
              role="button"
              href="/coaching-portal/settings/gym-locations"
            >
              {t("common:discard")}
            </a>
          </div>
        </form>
      </section>
    </main>
  );
};

module.exports = NewGymComponent;
